import Navbar from '../components/Navbar';
import HomePricing from '../components/HomePricing';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';


	const Pricing = () => {
		return (
			<div>
			  <Navbar />
			  <br></br><br></br>
			  <HomePricing />

				<Testimonials />
				<FAQ/>
			</div>
	
		)}

export default Pricing;